import { useState } from "react";
import { useTranslation } from "react-i18next";
import { brandLogo } from "@/mocks/home";

const amounts = ["$25", "$50", "$100", "$250"];

export default function Support() {
  const { t } = useTranslation();
  const [amount, setAmount] = useState("$50");

  return (
    <section id="support" className="w-full bg-accent-950 py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center justify-center rounded-md bg-background-50 px-5 py-3 mb-8">
          <img
            src={brandLogo}
            alt="barewitness films logo"
            title="barewitness films"
            className="h-10 w-auto object-contain"
          />
        </div>

        <div className="flex items-center justify-center gap-3 mb-5">
          <span className="h-px w-10 bg-primary-400"></span>
          <span className="font-label text-sm uppercase tracking-[0.3em] text-primary-300">
            {t("support.kicker")}
          </span>
          <span className="h-px w-10 bg-primary-400"></span>
        </div>

        <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50">
          {t("support.title")}
        </h2>
        <p className="mt-5 text-base leading-relaxed text-background-200 max-w-2xl mx-auto">
          {t("support.body")}
        </p>

        <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
          {amounts.map((value) => (
            <button
              key={value}
              type="button"
              onClick={() => setAmount(value)}
              className={`font-label text-base tracking-[0.06em] px-5 py-2.5 rounded-md border transition-colors cursor-pointer ${
                amount === value
                  ? "bg-primary-500 border-primary-500 text-accent-950"
                  : "border-background-100/30 text-background-100 hover:border-primary-300 hover:text-primary-200"
              }`}
            >
              {value}
            </button>
          ))}
        </div>

        <div className="mt-8">
          <a
            href="#contact"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-accent-950 font-label text-base uppercase tracking-[0.14em] px-8 py-3.5 rounded-md transition-colors cursor-pointer"
          >
            <i className="ri-heart-3-line text-xl"></i>
            {t("support.cta")} · {amount}
          </a>
        </div>
        <p className="mt-5 text-sm text-background-200/80">{t("support.note")}</p>
      </div>
    </section>
  );
}